import React from 'react';
import GeoPageTemplate from '../components/GeoPageTemplate';
import geoConfigs from '../config/geoConfigs';

const LocacaoNovaLima = () => {
  return <GeoPageTemplate {...geoConfigs.novalima} />;
};

export default LocacaoNovaLima;